var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.805,
    height: 24.999,
    viewBox: "0 0 19.805 24.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download_Outline",
    transform: "translate(-53.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M66.668.2a.6.6,0,0,0-.434-.2H56.485A3.3,3.3,0,0,0,53.2,3.28V21.718A3.3,3.3,0,0,0,56.485,25H69.72A3.3,3.3,0,0,0,73,21.718V7.074a.663.663,0,0,0-.176-.425Zm.176,1.938,4.125,4.33h-2.68a1.44,1.44,0,0,1-1.445-1.435Zm2.87,21.655H56.485a2.091,2.091,0,0,1-2.075-2.07V3.28a2.091,2.091,0,0,1,2.075-2.07h9.153V5.028a2.64,2.64,0,0,0,2.651,2.646H71.8V21.723A2.1,2.1,0,0,1,69.715,23.788Z",
    transform: "translate(0 0)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M152.344,181.606h-9.939a.605.605,0,1,0,0,1.211h9.944a.605.605,0,1,0,0-1.211Zm-5.409-2.167a.611.611,0,0,0,.439.2.6.6,0,0,0,.439-.2l3.539-3.8a.6.6,0,1,0-.879-.82L147.98,177.5v-6.59a.605.605,0,0,0-1.211,0v6.59l-2.49-2.675a.6.6,0,1,0-.879.82Z",
    transform: "translate(-84.275 -161.987)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadOutline);
export default __webpack_public_path__ + "static/media/Download_Outline.e4aa5de12ecef9af2468a846d68b6ed6.svg";
export { ForwardRef as ReactComponent };